@if (templateUtils$ | async; as utils) {
  @if (!utils.isMobile) {
    <sharry-header></sharry-header>
  } @else {
    <header class="header-content">
      <div>
        <button
          mat-icon-button
          class="sharry-small"
          (click)="onBack()">
          <sharry-icon registryName="caret-left"></sharry-icon>
        </button>
      </div>
      @if (content?.__typename === 'User' || $any(content)?.status === 'published') {
        <sharry-people-likes
          [content]="$any(content)"
          [showLikeButton]="showLikeButton"
          [showFavouriteButton]="showFavouriteButton"
          [showShareButton]="showShareButton"
          (favouriteClicked)="favouriteClicked.emit($event)"></sharry-people-likes>
      }
    </header>
  }
}
